import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData, PassOrderPageData } from '../../../api';
import { customerFacingPriceFormatter } from '../../../orderPage/utils';
import { withBookingFee } from '../../../orderPage/core/pricing';
import { isFixedScheduleMonthly } from '../../../managePassesPage/utils/passUtils';

interface PassMobileBookingBarProps {
  passOrderPage: PassOrderPageData;
  account: AccountData;
  onBookNowClick: () => void;
}

export const PassMobileBookingBar = ({ passOrderPage, account, onBookNowClick }: PassMobileBookingBarProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #e0e0e0',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
        zIndex: 1100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        paddingX: 2,
        paddingY: 1.5,
      }}>
      <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
        {customerFacingPriceFormatter(withBookingFee(passOrderPage.price, account), account)}
        {isFixedScheduleMonthly(passOrderPage.pass_type) && ` ${t('manage_passes.buy.perMonth')}`}
      </Typography>

      <Button
        variant="contained"
        onClick={onBookNowClick}
        sx={{
          paddingY: 1.5,
          paddingX: 4,
          fontWeight: 600,
          fontSize: '1rem',
        }}>
        {t('pass.buy_pass')}
      </Button>
    </Box>
  );
};
